// front-end utils

import { MantineSize } from "@mantine/core";
import { Doc } from "../../convex/_generated/dataModel";
import { HydratedEntry, omitField } from "../../convex/shared_util";

/**
 *
 * @param size
 * @param n
 */
export function mantineSizeSmaller(size: MantineSize, n: number = 1) {
  if (n === 0) {
    return size;
  }
  return mantineSizeSmaller(
    { xs: "xs", sm: "xs", md: "sm", lg: "md", xl: "lg" }[size] as MantineSize,
    n - 1
  );
}

/**
 *
 * @param size
 * @param n
 */
export function mantineSizeLarger(size: MantineSize, n: number = 1) {
  if (n === 0) {
    return size;
  }
  return mantineSizeLarger(
    { xs: "sm", sm: "md", md: "lg", lg: "xl", xl: "xl" }[size] as MantineSize,
    n - 1
  );
}

const dateFormatter = new Intl.DateTimeFormat(navigator.language, {
  timeZone: "UTC",
});

/**
 *
 * @param dateString
 */
export function formatDate(dateString: string) {
  return dateFormatter.format(new Date(dateString));
}


// TODO: dead code and duplicated — this export has no importer, while EntryDialog.tsx
// defines a byte-identical private copy that is the one actually used. Delete one and
// import the other; this file is the right home for it.
export const dehydrateSubjects = (subjects: HydratedEntry["subjects"]): Doc<"entries">["subjects"] =>
  subjects.map((s) => ({ id: s.doc._id, ...omitField(s, "doc") })) as Doc<"entries">["subjects"];


/**
 *
 * @param url
 * @param sizes
 */
export function makeSrcSetProp(
  url: string | undefined,
  sizes: number[] = [100, 200, 400, 800, 1600, 3200]
) {
  if (url === undefined) { return {}; }
  const lastIdx = sizes.length - 1;
  const srcSet = sizes
    .map((s, idx) =>
      idx !== lastIdx ? `${url}?tr=w-${s} ${s}w` : `${url} ${s}w`
    )
    .join(", ");
  return { srcSet };
}

/**
 * Wait for an element to appear in the DOM
 * @param selector
 * @param callback
 * @param timeout
 */
export function waitForElement(selector: string, callback: (element: Element) => void, timeout: number = 3000) {
  const observer = new MutationObserver((_, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      callback(element);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  if (timeout > 0) {
    setTimeout(() => {
      observer.disconnect();
    }, timeout);
  }
  return observer;
}
